/* eslint-disable indent */
/* eslint-disable quotes */
import qs from 'qs'
import request from './request'
import store from '@/store'

const userAgentinfo = window.navigator.userAgent
let headerinfo = {}
if (userAgentinfo.indexOf('gkztc') > -1 && userAgentinfo.indexOf('Android') > -1) {
    headerinfo = {
        'GK-CLIENT-ID': 'gkztcandroid',
        'GK-CLIENT-SECRET': 'root4gkztc'
    }
} else if (userAgentinfo.indexOf('gkztc') > -1 && userAgentinfo.indexOf('iOS') > -1) {
    headerinfo = {
        'GK-CLIENT-ID': 'gkztcios',
        'GK-CLIENT-SECRET': 'ios4gkztc'
    }
} else if(userAgentinfo.toLowerCase().indexOf('micromessenger') > -1){
    //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
    // wx.miniProgram.getEnv((res)=>{
    //     if (res.miniprogram) {
    //         headerinfo = {
    //             'GK-CLIENT-ID': 'gkzcMinapp4zy',
    //             'GK-CLIENT-SECRET':'minapp4gkztc'
    //         }
    //     } else {
    //         headerinfo = {
    //             'GK-CLIENT-ID': 'gkztcweb',
    //             'GK-CLIENT-SECRET':'web4gkztc'
    //         }
    //     }
    //  })

     headerinfo = {
        'GK-CLIENT-ID': 'gkztcweb',
        'GK-CLIENT-SECRET':'web4gkztc'
    }
} else {
    headerinfo = {
        'GK-CLIENT-ID': 'gkztcweb',
        'GK-CLIENT-SECRET':'web4gkztc'
    }
}

// 发送请求
function fetch (method, url, data = null, headers = null,obj) { 
    let options = {
        method: method,
        url: url,
        headers: Object.assign({}, headers)
    }
    if(obj){
        options = Object.assign(options, obj)
    }
    if (method === 'get') {
        options.params = data
    } else {
        options.data = qs.stringify(data)
    }
    return request(options)
}

function uploadFile (method, url, data = null, headers = null,obj) { 
    // let defaultHeaders = {
    //     "Content-Type": "multipart/form-data;boundary="+new Date().getTime()
    // }
    let defaultHeaders = {
        "Content-Type": "multipart/form-data;"
    }
    let options = {
        method: method,
        url: url,
        headers: headers === "form" ? {} : Object.assign(defaultHeaders, headers)
    }
    if(obj){
        options = Object.assign(options, obj)
    }
    options.data = data
    
    return request(options)
}

const Http = {
    get: (url, data, headers,obj) => fetch('get', url,data, Object.assign(headerinfo, headers),obj),
    post: (url, data, headers,obj) => fetch('post', url, data, Object.assign(headerinfo, headers),obj),
    upload: (url, data, headers,obj) => uploadFile('post',url, data, Object.assign(headerinfo, headers),obj)
}
export default Http